import React, { useState, useEffect } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import InputMasked from "react-input-mask";
import Tour from "reactour";

//Service
import api from "../../../service/api";
import { ToastContainer } from "react-toastify";

//Components
import Main from "../../../components/Main/index";
import Header from "../../../components/Header";
import NavTabs from "../../../components/NavTabs";
import Input from "../../../components/Input";
import Button from "../../../components/Button";
import Modal from "../../../components/ModalSuccessMessage";
import Select from "../../../components/Select";
import ErrorMessage from "../../../components/ErrorMessage";
import { TitleTour, ContentText } from "../../../components/ReactourComponents/styles";

//Styles
import { Legend, ContainerButton } from "./styles";

//Routes
import routesCard from "../../../routes/card.routes";

//Help Functions
import { openModal } from "../../../helpers/modalFunctions";

//Assets
import colors from "../../../assets/css/colors";

// Utils
import { toastCreate, toastUpdate } from "../../../utils/notifications/toast";
import { notifysFieldsForm } from "../../../utils/notifications/notifyForm";
import convertAmountInCents from "../../../utils/amountInCents";

const NoPresentCard = () => {
    const [client, setClient] = useState({
        id: "",
        firstName: ""
    });

    const [searchResults, setSearchResults] = useState([]);

    const [errorOnSubmit, setErrorOnSubmit] = useState(false);
    const [errorOnReturnApi, setErrorOnReturnApi] = useState(false);

    const [phoneNumberPrefix, setPhoneNumberPrefix] = useState("+55");

    const [tutorialTourIsOpen, setTutorialTourIsOpen] = useState(false);

    const login = useSelector((state: {login: any}) => state.login);
    const history = useHistory();

    function useQuery() {
        return new URLSearchParams(useLocation().search);
    }

    const query = useQuery();
    
    useEffect(() => {
        if(login.user.groups.cm3a2 === false){
            history.push("/admin/dashboard");
        }

        if(query.get("tutorial") !== null){
            setTutorialTourIsOpen(true);
        }
    }, []);

    useEffect(() => {
        const getSearchForClients = async () => {
            if(client.firstName !== ""){
                const getClients = await api.get(`/buyer/list?id=${login.user.branchsId}&filter=${client.firstName.toUpperCase()}`);
                
                setSearchResults(getClients.data.Buyers);
            }
        }

        getSearchForClients();
    }, [client.firstName]);

    const formValidationWithYup = Yup.object().shape({
        phoneNumber: Yup.string().min(10).required("Required"),
        cardName: Yup.string().required("Required"),
        cardNumber: Yup.string().required("Required"),
        expirationDate: Yup.string().required("Required"),
        cvv: Yup.string().required("Required"),
        amount: Yup.string().required("Required"),
        installments: Yup.string().required(),
        order: Yup.string().required()
    });

    const searchForErrors = (errors: Object) => {
        if(errors !== {}){
          setErrorOnSubmit(true)
        } else {
          setErrorOnSubmit(false)
        }
    }

    const handleChangeClient = async (e: any) => {
        setClient({id: client.id, firstName: e.target.value});
    }

    const handlePhoneNumberPrefixChange = (e: string) => {
        setPhoneNumberPrefix(e);
    }

    const stepsTutorial = [
        {
            selector: "#form-card",
            content: () => (
                <div>
                    <TitleTour>Cartão não presente</TitleTour>
                    <ContentText>Para realizar uma venda avulsa com um cartão não presente, preencha os campos, você pode começar pelo campo de contato do cliente.</ContentText>
                </div>
            )
        },
        {
            selector: "#card-data-form",
            content: () => (
                <div>
                    <TitleTour>Cartão não presente</TitleTour>
                    <ContentText>Depois você pode preencher os campos com as informações do cartão.</ContentText>
                </div>
            )
        },
        {
            selector: "#sell-data-form",
            content: () => (
                <div>
                    <TitleTour>Cartão não presente</TitleTour>
                    <ContentText>Por fim, preencha as informações da venda.</ContentText>
                </div>
            )
        },
        {
            selector: "#amount",
            content: () => (
                <div>
                    <TitleTour>Cartão não presente</TitleTour>
                    <ContentText>Os centavos devem ser separados com vírgula, exemplo: 250,00.</ContentText>
                </div>
            )
        },
        {
            selector: "#button-submit",
            content: () => (
                <div>
                    <TitleTour>Cartão não presente</TitleTour>
                    <ContentText>Clique no botão e aguarde a confirmação.</ContentText>
                </div>
            )
        },
    ]
    
    return(
        <Main>
            <ToastContainer />
            <Header title="Cartão" subTitle="Associe cartões aos seus clientes para pagamentos via cartão de crédito" subTitleWidth={240}/>
            <NavTabs tabs={routesCard}/>
            <Modal text="Venda realizada com Sucesso"/>
            <Tour
                steps={stepsTutorial}
                isOpen={tutorialTourIsOpen}
                onRequestClose={() => setTutorialTourIsOpen(false)}
                accentColor={colors.primary}
                showNumber={false}
                showNavigation
                showNavigationNumber={false}
                showButtons
            />

                <Formik
                    initialValues={{
                        phoneNumber: "",
                        cardName: "",
                        cardNumber: "",
                        expirationDate: "",
                        cvv: "",
                        amount: "",
                        installments: "",
                        order: ""
                    }}
                    validationSchema={formValidationWithYup}
                    onSubmit={async (values) => {
                        let amountInCents = convertAmountInCents(values.amount)

                        const [month, year] = values.expirationDate.split("/");
                        const first4Numbers = values.cardNumber.slice(0, 4);
                        const last4Numbers = values.cardNumber.slice( values.cardNumber.length - 4, values.cardNumber.length);
                        const cardNumbers = values.cardNumber.split(" ").join("");
                        const phone = values.phoneNumber.replace("(", " ").replace(")", " ").replace("-", " ").split(" ").join("");

                        try {
                            await api.post("/card/notpreset/create", {
                                "branchsId": login.user.branchsId,
                                "apiOwnerId": login.user.powerUser === true ? "ZOOP" : login.user.branchs.apiOwner.description,
                                "phoneSms": phone,
                                "amount": amountInCents,
                                "numberInstalments": values.installments,
                                "holder_name": values.cardName,
                                "description": values.order,
                                "card_number": cardNumbers,
                                "first4Digits": first4Numbers,
                                "last4Digits": last4Numbers,
                                "expirationMonth": month,
                                "expirationYear": year,
                                "security_code": values.cvv,
                                "sellerOwnerPayId": login.user.branchs.sellerOwnerPayId,        
                            });
                            setErrorOnReturnApi(false);
                            toastUpdate("btnSubmit","success",2000,"Sucesso" )
                            openModal("exampleModal");
                        } catch (e) {
                            setErrorOnReturnApi(true);
                            toastUpdate("btnSubmit","error",4000, "Ocorreu um problema, entre em contato com o suporte." )
                        }
                        
                    }}
                >
                    {({ handleChange, errors, handleSubmit }) => {
                        return(
                            <>
                                <div className="row">
                                    <div className="col-12 col-lg-4">
                                        <Form id="form-card">
                                            <fieldset>
                                                <Legend>Dados da venda</Legend>
                                                <div className="d-flex col-12 p-0">
                                                    <div className="col-3 p-0 pr-2">
                                                        <Select value={phoneNumberPrefix} onChange={(e) => handlePhoneNumberPrefixChange(e.target.value)}>
                                                            <option disabled hidden value={phoneNumberPrefix}>{phoneNumberPrefix}</option>
                                                            <option value="+55">Brasil (55)</option>
                                                            <option value="+598">Uruguai (598)</option>
                                                            <option value="+1">Estados Unidos (1)</option>
                                                            <option value="+52">México (52)</option>
                                                        </Select>
                                                    </div>
                                                    <div className="col-9 p-0">
                                                        <Field
                                                            id="phoneNumber"
                                                            name="phoneNumber"
                                                            className="inputCustom" 
                                                            style={{borderColor: `${errorOnSubmit && errors.phoneNumber ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                                            placeholder="Telefone" 
                                                            type="tel"
                                                            as={Input}
                                                        />
                                                    </div>
                                                </div>
                                            
                                            </fieldset>
                                        </Form>
                                    </div>
                                    
                                    <div className="col-12 col-lg-4">
                                        <Form id="card-data-form">
                                            <fieldset>
                                                <Legend>Dados do cartão</Legend>
                                                    <Field 
                                                        id="cardName" 
                                                        name="cardName" 
                                                        className="inputCustom" 
                                                        style={{borderColor: `${errorOnSubmit && errors.cardName ? "red" : "rgba(194, 194, 194, 0.2)"}`, textTransform:"uppercase"}}
                                                        placeholder="Nome como no Cartão" 
                                                        as={Input}
                                                    />
                                                    <Field 
                                                        name="cardNumber" 
                                                        >
                                                        {() => (
                                                            <InputMasked
                                                                id="cardNumber" 
                                                                className="input-masked inputCustom" 
                                                                style={{borderColor: `${errorOnSubmit && errors.cardNumber ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                                                placeholder="Número" 
                                                                onChange={handleChange}
                                                                mask="9999 9999 9999 9999"
                                                                maskChar={null}
                                                                type="tel"

                                                            />
                                                        )}
                                                    </Field>

                                                    <Field 
                                                        name="expirationDate" 
                                                        >
                                                        {() => (
                                                            <InputMasked
                                                                id="expirationDate" 
                                                                className="input-masked inputCustom" 
                                                                style={{borderColor: `${errorOnSubmit && errors.expirationDate ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                                                placeholder="Expiração" 
                                                                onChange={handleChange}
                                                                mask="99/9999"
                                                                type="tel"
                                                            />
                                                        )}
                                                    </Field>        
                                                    
                                                    <Field 
                                                        name="cvv" 
                                                    >
                                                        {() => (
                                                            <InputMasked
                                                                id="cvv" 
                                                                className="input-masked inputCustom" 
                                                                style={{borderColor: `${errorOnSubmit && errors.cvv ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                                                placeholder="CVV" 
                                                                onChange={handleChange}
                                                                type="tel"
                                                                mask="9999"                                                        
                                                            />
                                                        )}
                                                    </Field>
                                            </fieldset>
                                        </Form>
                                    </div>
                                    <div className="col-12 col-lg-4">
                                        <Form id="sell-data-form">
                                            <fieldset>
                                                <Legend>Transação</Legend>
                                                <Field 
                                                    id="amount" 
                                                    name="amount" 
                                                    className="inputCustom" 
                                                    style={{borderColor: `${errorOnSubmit && errors.amount ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                                    placeholder="Valor da Compra" 
                                                    type="text"
                                                    as={Input}
                                                />
                                                <Field 
                                                    id="installments" 
                                                    name="installments" 
                                                    className="inputCustom" 
                                                    style={{borderColor: `${errorOnSubmit && errors.installments ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                                    placeholder="Parcelas" 
                                                    type="number" 
                                                    as={Input}
                                                />
                                                <Field 
                                                    id="order" 
                                                    name="order" 
                                                    className="inputCustom" 
                                                    style={{borderColor: `${errorOnSubmit && errors.order ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                                    placeholder="Ref. Pedido / Compra" 
                                                    as={Input}
                                                />
                                            </fieldset>
                                        </Form>
                                    </div>
                                </div>
                                
                                <Form>
                                    {
                                        errorOnReturnApi ?
                                            <ErrorMessage>
                                                Falha ao processar transação
                                            </ErrorMessage> : null
                                    }
                                    <ContainerButton className="col-12 col-lg-4">
                                        {
                                            notifysFieldsForm(errors, errorOnSubmit)
                                        }
                                        <Button
                                            id="button-submit"
                                            type="submit"
                                            onClick={() => {
                                                searchForErrors(errors);
                                                toastCreate("btnSubmit", "info", 2000, "Processando")
                                            }}
                                        >
                                            Efetuar Venda
                                        </Button>
                                    </ContainerButton>
                                </Form>
                            </>
                        )
                    }}
                </Formik>
        </Main>
    )
}

export default NoPresentCard;